module.exports = __webpack_public_path__ + "static/media/nb.395e6c5c.png";